'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
const components_display_Heading_HeadingLevel = require('../../display/Heading/HeadingLevel.cjs.js');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_navigation_LegacyButton_Button = require('../../navigation/LegacyButton/Button.cjs.js');
const components_navigation_Link_Link = require('../../navigation/Link/Link.cjs.js');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const container = "_container_uuy3h_1";
const link = "_link_uuy3h_10";
const iconContainer = "_icon-container_uuy3h_20";
const mediaContainer = "_media-container_uuy3h_25";
const heading = "_heading_uuy3h_31";
const description = "_description_uuy3h_42";
const smallText = "_small-text_uuy3h_60";
const primaryCtaContainer = "_primary-cta-container_uuy3h_79";
const secondaryCtaContainer = "_secondary-cta-container_uuy3h_88";
const secondaryCtaText = "_secondary-cta-text_uuy3h_97";
const styles = {
	container: container,
	link: link,
	iconContainer: iconContainer,
	mediaContainer: mediaContainer,
	heading: heading,
	description: description,
	smallText: smallText,
	primaryCtaContainer: primaryCtaContainer,
	secondaryCtaContainer: secondaryCtaContainer,
	secondaryCtaText: secondaryCtaText
};

const Content = ({ iconName, iconColor, media, heading, description, smallText }) => {
  return React__default.default.createElement(
    React.Fragment,
    null,
    iconName && React__default.default.createElement(
      "div",
      { "data-testid": "icon", className: styles.iconContainer, "data-zds": true },
      React__default.default.createElement(components_display_Icon_Icon.Icon, { color: iconColor ? theme_LegacyColorMap.LegacyColorMap[iconColor] : void 0, name: iconName, size: 50 })
    ),
    media && React__default.default.createElement("div", { className: styles.mediaContainer, "data-zds": true }, media),
    heading && React__default.default.createElement(
      components_display_Heading_HeadingLevel.HeadingLevel,
      null,
      React__default.default.createElement(components_display_Heading_Heading.Heading, { className: styles.heading }, heading)
    ),
    description && React__default.default.createElement("div", { className: styles.description, "data-zds": true }, description),
    smallText && React__default.default.createElement("p", { className: styles.smallText, "data-zds": true }, smallText)
  );
};
const PrimaryCTA = ({ ctaHref, onCtaClick, onCtaKeyDown, ctaText }) => React__default.default.createElement(
  "div",
  { className: styles.primaryCtaContainer, "data-zds": true },
  React__default.default.createElement(components_navigation_LegacyButton_Button.LegacyButton, { color: "primary", href: ctaHref, onClick: onCtaClick, onKeyDown: onCtaKeyDown, "data-testid": "cta-button" }, ctaText)
);
const SecondaryCTA = ({ secondaryCtaHref, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaText }) => {
  return React__default.default.createElement(
    "div",
    { className: styles.secondaryCtaContainer, "data-zds": true },
    React__default.default.createElement(
      components_navigation_Link_Link.Link,
      { "data-testid": "cta-secondary-button", href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" },
      React__default.default.createElement("div", { className: styles.secondaryCtaText, "data-zds": true }, secondaryCtaText)
    )
  );
};
function Block({ isLink = false, isCentered = false, description, iconName, iconColor = "blue", media, ctaText, ctaHref, secondaryCtaText, secondaryCtaHref, heading, smallText, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown }) {
  const hasPrimaryCta = Boolean(ctaText && (ctaHref || onCtaClick));
  const hasSecondaryCta = Boolean(secondaryCtaText && (secondaryCtaHref || onSecondaryCtaClick));
  const contentProps = {
    iconName,
    iconColor,
    media,
    heading,
    description,
    smallText
  };
  const primaryCTAProps = {
    ctaHref,
    onCtaClick,
    onCtaKeyDown,
    ctaText
  };
  const secondaryCTAProps = {
    secondaryCtaHref,
    onSecondaryCtaClick,
    onSecondaryCtaKeyDown,
    secondaryCtaText
  };
  return React__default.default.createElement("div", { className: styles.container, "data-zds": true, style: {
    "--_zds-block-align-items": isCentered ? "center" : "flex-start",
    "--_zds-block-text-align": isCentered ? "center" : "left"
  } }, isLink ? React__default.default.createElement(
    components_navigation_Link_Link.Link,
    { className: styles.link, "data-testid": "link-wrapper", href: ctaHref, onClick: onCtaClick, onKeyDown: onCtaKeyDown },
    React__default.default.createElement(Content, Object.assign({}, contentProps))
  ) : React__default.default.createElement(
    React.Fragment,
    null,
    React__default.default.createElement(Content, Object.assign({}, contentProps)),
    hasPrimaryCta && React__default.default.createElement(PrimaryCTA, Object.assign({}, primaryCTAProps)),
    hasSecondaryCta && React__default.default.createElement(SecondaryCTA, Object.assign({}, secondaryCTAProps))
  ));
}

exports.Block = Block;
//# sourceMappingURL=Block.cjs.js.map
